<template>
    <v-container
        fluid
        class="sidebar-content general-sidebar"
    >
        <v-list>
            <v-list-item
                v-for="(item, index) in data.items"
                :key="`item-${index}`"
                class="models-nav-item pb-8"
            >
                <div v-if="item.submenu">
                    <span class="main-nav-item main-nav-item_start">
                        <span class="icon-holder">
                            <div
                                class="rounded"
                                :style="{ 'backgroundImage': 'url(' + item.preview + ')' }"
                                v-if="item.preview"
                            />
                            <div
                                class="rounded"
                                :style="{ 'backgroundImage': 'url(' + item.icon + ')' }"
                                v-else-if="item.icon"
                            />
                        </span>
                        <span class="nav-text global-nav">
                            {{ data.widgetType === 'models' ? data.widgetTitle : item.text }}
                        </span>
                    </span>
                    <div
                        class="scrollbar"
                        v-bar="{
                            overrideFloatingScrollbar: true,
                            observerThrottle: 0,
                            draggingPhantomDelay: 0,
                            scrollingPhantomDelay: 0,
                            resizeRefresh: false
                        }"
                    >
                        <div
                            class="scrollable"
                            ref="scrollable"
                        >
                            <v-list class="divider-left sub-menu props-list">
                                <v-list-item
                                    v-for="(subitem, subindex) in item.submenu"
                                    class="pb-2 pl-4"
                                    :key="`subitem-${subindex}`"
                                >
                                    <a
                                        href="#"
                                        :class="{ 'active': subitem.active }"
                                        @click.prevent="setActive(subitem)"
                                    >
                                        {{ subitem.text }}
                                    </a>
                                </v-list-item>
                            </v-list>
                        </div>
                    </div>
                </div>
                <a
                    v-else
                    href="#"
                    class="main-nav-item main-nav-item_start"
                    :class="{ active: item.active}"
                    @click.prevent="setActive(item)"
                >
                    <span class="icon-holder">
                        <div
                            class="rounded"
                            :style="{ 'backgroundImage': 'url('+ item.preview +')' }"
                            v-if="item.preview"
                        />
                        <div
                            class="rounded"
                            :style="{ 'backgroundImage': 'url('+ item.icon +')' }"
                            v-else-if="item.icon"
                        />
                    </span>
                    <span class="nav-text global-nav">
                        {{ item.text }}
                    </span>
                </a>
            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'ModelsSidebar',
        props: [
            'data',
            'handler'
        ],
        mounted() {
            this.handler();
        },
        methods: {
            setActive(currentItem) {
                if (!currentItem.active)
                    this.data.items.forEach(item => {
                        if (item.submenu) {
                            item.submenu.forEach(subitem => {
                                subitem.active = currentItem.link === subitem.link;
                            });
                        }
                        else
                            item.active = currentItem.link === item.link;
                    });

                EventBus.$emit('updateLoadedWidgets', {
                    id: currentItem.id,
                    link: currentItem.link,
                    active: true,
                    widgetType: currentItem.id
                });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/layout/sidebar/ModelsSidebar.vue